<template>
  <!-- 实时监控左侧机构树 组件-->
  <div class="contain" :class="showTree ? '' : 'alert_tree'">
    <div class="title" v-if="showTree">
      <span>{{ $t('UserListM') }}</span>
      <div v-if="tenantIdSession ==='352645311809351680'" class="order-btn" @click="distributeOrder">派发工单</div>
    </div>
    <div class="tree-block" :class="[isPack ? '' : 'tree-block-pack']">
      <el-aside>
        <div class="serachLine" v-if="showTree">
          <el-input
            :placeholder="$t('PleaseEnterUseName')"
            v-model="userName"
            class="serachBarInput"
            clearable
            @clear="clearInput"
          >
          </el-input>
          <i class="line"></i>
          <el-select v-model="helmetStatusValue" multiple :collapse-tags="language === 'en'? true : false" size="mini" value-key="id" class="serachBarSelet" >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              class="serachBarSeletOption"
            >
            </el-option>
          </el-select>
        </div>
        <span v-if="firstOuId" class="open-all" @click="openALL">{{ openText }}</span>
        <el-tree
          v-if="showAllOpen"
          :data="deviceData"
          :props="defaultProps"
          node-key="nodeId"
          :default-expanded-keys="defaultExpandIds"
          @node-expand="handleNodeExpand"
          @node-collapse="handleNodeCollapse"
          :expand-on-click-node="false"
          @node-click="handleNodeClick"
          :current-node-key="currentNode.nodeId"
          highlight-current
          class="monitorTree"
          :filter-node-method="filterNode"
          ref="dataConfigTree"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <!-- 在线 智能帽衬 -->
            <span
              v-if="
                node.childNodes.length === 0 &&
                  node.data.device &&
                  node.data.device.onlineStatus === '1' &&
                  node.data.device.specType === 0
              "
              class="onlineIcon node-txt"
              :class="!isDefaultTheme ? ' tree-jls-on-night' : 'tree-jls-on-day'"
            ></span>
            <!-- 在线 智能安全帽/国标智能安全帽 -->
            <span
              v-if="
                node.childNodes.length === 0 &&
                  node.data.device &&
                  node.data.device.onlineStatus === '1' &&
                  [1, 3].includes(node.data.device.specType)
              "
              class="onlineIcon node-txt"
              :class="!isDefaultTheme ? 'tree-gk3-on-night' : 'tree-gk3-on-day'"
            ></span>
            <span
              v-if="
                node.childNodes.length === 0 &&
                  node.data.device &&
                  node.data.device.onlineStatus === '1' &&
                  node.data.device.specType === 2
              "
              class="onlineIcon node-txt"
              :class="!isDefaultTheme ? 'tree-law-on-night' : 'tree-law-on-day'"
            ></span>
            <!-- 离线 智能帽衬 -->
            <span
              v-if="
                node.childNodes.length === 0 &&
                  node.data.device &&
                  node.data.device.onlineStatus === '0' &&
                  node.data.device.specType === 0
              "
              class="onlineIcon node-txt"
              :class="!isDefaultTheme ? 'tree-jls-off-night' : 'tree-jls-off-day'"
            ></span>
            <!-- 离线 智能安全帽/国标智能安全帽 -->
            <span
              v-if="
                node.childNodes.length === 0 &&
                  node.data.device &&
                  node.data.device.onlineStatus === '0' &&
                  [1, 3].includes(node.data.device.specType)
              "
              class="onlineIcon node-txt"
              :class="!isDefaultTheme ? 'tree-gk3-off-night' : 'tree-gk3-off-day'"
            ></span>
            <!-- 离线 执法仪 -->
            <span
              v-if="
                node.childNodes.length === 0 &&
                  node.data.device &&
                  node.data.device.onlineStatus === '0' &&
                  node.data.device.specType === 2
              "
              class="onlineIcon node-txt"
              :class="!isDefaultTheme ? 'tree-low-off-night' : 'tree-low-off-day'"
            ></span>
            <!-- 定位设备 -->
            <span
              v-if="
                node.childNodes.length === 0 &&
                  node.data.device &&
                  node.data.device.onlineStatus === '0' &&
                  node.data.device.specType === 4
              "
              class="onlineIcon node-txt"
              :class="!isDefaultTheme ? 'tree-lposition-off-night' : 'tree-lposition-off-day'"
            ></span>
            <span
              v-if="
                node.childNodes.length === 0 &&
                  node.data.device &&
                  node.data.device.onlineStatus === '1' &&
                  node.data.device.specType === 4
              "
              class="onlineIcon node-txt"
              :class="!isDefaultTheme ? 'tree-dposition-off-night' : 'tree-dposition-off-day'"
            ></span>
            <span v-if="node.childNodes.length === '0' && !node.data.device" class="unallotIcon"></span>
            <span
              :class="[
                node.childNodes.length === 0 && node.data.device && node.data.device.onlineStatus === '1'
                  ? 'onlineColor'
                  : '',
                node.childNodes.length === 0 && node.data.device && node.data.device.onlineStatus === '0'
                  ? 'offlineColor'
                  : 'nodeColor',
              ]"
              class="white fz16 treefamily mb2 ml2 fw500 node-txt "
            >
              {{ node.label }}
            </span>
            <span v-if="node.childNodes.length > 0" class="ml5 unit-color"
              >({{ data.onlineOfAll }}/{{ data.totalOfAll }})</span
            >
          </span>
        </el-tree>
      </el-aside>
      <div class="arrow-count" @click="handleCount" v-if="isPack && showTree">
        <span>{{ $t('viewData') }}</span>
        <i></i>
      </div>
      <div class="pack-up" @click="triggerPack" v-if="isPack && showTree">
        <span>{{ $t('Stow') }}</span>
        <i></i>
      </div>
      <div class="extend-up" @click="triggerPack" v-if="!isPack && showTree">
        <span>{{ $t('openS') }}</span>
        <i></i>
      </div>
      <div class="extend-up-numb" @click="handleCount" v-if="!isPack && showTree">
        <span>{{ $t('viewData') }}</span>
        <i></i>
      </div>
    </div>
  </div>
</template>

<script>
import { findDeviceList, locationRecord, gpsRecord } from '@/api/monitor'
import { getSession } from '@/api/common'
import { mapGetters } from 'vuex'
import store from '@/store/index'
export default {
  props: {
    showTree: {
      type: Boolean,
    },
    searchName: {
      type: String,
    },
  },
  data() {
    return {
      isPack: true,
      tenantIdSession: null,
      theme: localStorage.getItem('theme'),
      userName: '',
      helmetStatusValue: [1, 0],
      findDeviceListFlag: false,
      pollInterval: null,
      statusList: [0, 1, 2],
      deviceData: [],
      // 第一个节点
      firstOuId: '',
      options: [
        {
          value: 'all',
          label: this.$t('whole'),
        },
        {
          value: 1,
          label: this.$t('onLine'),
        },
        {
          value: 0,
          label: this.$t('offLine'),
        },
        {
          value: 2,
          label: this.$t('Unbound'),
        },
      ],
      // 机构树设备数据
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      // 这里存放要默认展开的节点 id
      defaultExpandIds: [],
      // 默认展开
      tableData: [],
      // 当前选中的节点
      currentNode: {},
      openText: this.$t('openS') + this.$t('all'),
      showAllOpen: true,
      // 用户树查询条件 传值 数据列表查询
      userTreeQueryParam: {
        // 默认查询在线 + 离线
        statusList: '0,1',
        userName: null,
      },
      language: localStorage.getItem('lang'),
    }
  },
  computed: {
    ...mapGetters(['isDefaultTheme']),
  },
  mounted() {
    this.tenantIdSession = getSession('tenantId')
    this._findDeviceList([0, 1])
    this.pollInterval = setInterval(() => {
      if (this.findDeviceListFlag && getSession('access_token')) {
        this._findDeviceList(this.statusList)
      }
    }, 10000)
  },
  inject: ['openPiont'],
  methods: {
    distributeOrder(){
      store.commit('currentIndex', 'order')
      this.$router.push({ path: '/newIndex/empty/order' })
    },
    // 展开全部
    openALL() {
      if (this.openText === this.$t('openS') + this.$t('all')) {
        this.openText = this.$t('Stow')
        for (let item of this.deviceData) {
          if (item.id) {
            this.handleNodeExpand(item)
          }
          this.addChildrenIds(item)
        }
      } else {
        this.showAllOpen = false
        this.defaultExpandIds = []
        this.openText = this.$t('openS') + this.$t('all')
        this.$nextTick(() => {
          this.showAllOpen = true
        })
      }
    },
    // 循环展开树子节点
    addChildrenIds(data) {
      const _this = this
      if (data.children) {
        data.children.forEach(function(item) {
          if (item.id) {
            _this.handleNodeExpand(item)
          }
          if (item.children) {
            _this.addChildrenIds(item)
          }
        })
      }
    },
    clearInput() {
      this._findDeviceList(this.statusList)
    },
    // 查询全部设备列表
    _findDeviceList(statusList) {
      if (statusList[0] === 'all') {
        this.statusList = [0, 1, 2]
      } else {
        this.statusList = statusList
      }

      let param = {
        userName: this.userName,
        statusList: this.statusList,
      }
      findDeviceList(param).then(res => {
        this.findDeviceListFlag = true
        if (res.state === 0 && res.data[0]) {
          this.deviceData = res.data
          this.firstOuId = res.data[0].id
          if (this.defaultExpandIds.indexOf(this.firstOuId) === -1) {
            this.getRoleTreeRootNode(this.firstOuId)
          }
          this.$nextTick(() => {
            // 回显默认选择的item 高亮
            if (this.currentNode.nodeId) {
              this.$refs.dataConfigTree.setCurrentKey(this.currentNode.nodeId)
            }
          })
        } else {
          this.deviceData = null
        }
      })
    },
    // 获取树形结构默认展开节点
    getRoleTreeRootNode(firstOuId) {
      if (!this.$route.query.id) {
        this.defaultExpandIds.push(firstOuId)
      }
    },
    filterNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 机构树点击事件
    handleNodeClick(data) {
      this.currentNode = data
      try {
        console.log("handleNodeClick", data);
        if (data.device && data.device.deviceName && data.device.deviceName != 'undefined') {
          let param = {
            deviceName: data.device.deviceName,
            limit: 1,
          }
          // 不同平台调不一样的获取坐标接口
          if (data.device.specType === 0 || data.device.specType === 4) {
            // 智能帽衬
            locationRecord(param).then(res => {
              this.commonTransform(data, res)
            })
          } else {
            // 其它设备类型使用该接口
            gpsRecord(data.device.deviceName).then(res => {
              this.commonTransform(data, res)
            })
          }
          // 地图能出来时设置
          this.$emit('update:isOfflineMap', false)
          // 树点击时查找位置信息
        } else {
          // 未绑定设备用户 只展开历史数据
          console.log('未绑定设备用户', data)
          // 查询历史绑定设备数据
          let obj = {}
          obj.userName = data.name
          obj.userId = data.userId
          obj.tenantId = data.tenantId
          obj.position = {}
          obj.status = 0
          obj.onlineStatus = ''
          obj['noBindDevice'] = true
          obj.device = {}
          obj.deviceName = ''
          obj.tableData = ''
          obj.serialNumber = ''
          obj.specModel = ''
          obj.specType = ''
          this.$emit('formatData', obj)
          this.openPiont(obj)
        }
      } catch{
        console.log("地图出不来时设置");
        // 地图出不来时设置
        this.$emit('update:isOfflineMap', true)
        if (data.device && data.device.deviceName && data.device.deviceName !== 'undefined') {
          let param = {
            deviceName: data.device.deviceName,
            limit: 1,
          }
          // 不同平台调不一样的获取坐标接口
          if (data.device.specType === 0) {
            locationRecord(param).then(res => {
              this.commonTransform(data, res)
            })
          } else {
            gpsRecord(data.device.deviceName).then(res => {
              this.commonTransform(data, res)
            })
          }
        }
      }
    },
    // 转换坐标方法
    commonTransform(data, res) {
      console.log("commonTransform", data, res);
        let obj = {}
        // 转换坐标
        let position = res.data && res.data[0] && res.data[0].position ? res.data[0].position : {lat:"23.146498058900377", lng:"113.34185451649259"}
        console.log(position)
        // 控制新版头盔面板打开
        obj.userName = data.name
        obj.userId = data.userId
        obj.position = position
        obj.deviceName = data.device.deviceName
        obj.tableData = data.device.deviceName
        obj.status = data.device.status
        obj.tenantId = data.tenantId
        obj.onlineStatus = data.device.onlineStatus
        obj.serialNumber = data.device.serialNumber
        obj.specModel = data.device.specModel
        obj.specType = data.device.specType
        obj.device = data.device
        obj.timestamp = res && res.data && res.data[0] ? res.data[0].timestamp : ''
        // 触发执行父组件
        // 存储当前选中头盔
        if (data.device.specType === 0) {
          this.$store.commit('ExitjlsHelmetInfo', obj)
        } else {
          obj.timestamp = res && res.data && res.data[0] ? res.data[0].timestamp : ''
          this.$store.commit('ExitjlsHelmetInfo', '')
        }
        this.$emit('formatData', obj)
        this.$store.commit('currentHelmetData', obj)
        // 打开弹窗
        this.openPiont(obj)
    },
    // 树节点展开
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false
      this.defaultExpandIds.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true
          return true
        }
      })
      if (!flag) {
        // 不存在则存到数组里
        this.defaultExpandIds.push(data.id)
      }
    },
    // 树节点关闭
    handleNodeCollapse(data) {
      if (data.id === this.firstOuId) {
        this.openText = this.$t('openS') + this.$t('all')
        this.defaultExpandIds = []
        return
      }
      // 删除当前关闭的节点
      this.defaultExpandIds.some((item, i) => {
        if (item === data.id) {
          this.defaultExpandIds.splice(i, 1)
        }
      })
      if (data.children) {
        this.removeChildrenIds(data) // 这里主要针对多级树状结构，当关闭父节点时，递归删除父节点下的所有子节点
      }
    },
    // 删除树子节点
    removeChildrenIds(data) {
      const ts = this
      if (data.children) {
        data.children.forEach(function(item) {
          const index = ts.defaultExpandIds.indexOf(item.id)
          if (index > 0) {
            ts.defaultExpandIds.splice(index, 1)
          }
          if (item.id) {
            ts.removeChildrenIds(item)
          }
        })
      }
    },
    triggerPack() {
      this.isPack = !this.isPack
    },
    handleCount() {
      this.$store.commit('handleshowHelmetTable', true)
    },
  },
  watch: {
    // 监听路由变化
    $route: {
      handler() {
        if (this.$route.query.id) {
          this.defaultExpandIds = this.defaultExpandIds.splice(0, this.defaultExpandIds.length)
          this.defaultExpandIds.push(this.$route.query.id)
        }
      },
      immediate: true,
    },
    // 在线离线搜索条件监听
    helmetStatusValue: function(val, oldval) {
      let newindex = val.indexOf('all'),
        oldindex = oldval.indexOf('all') //获取val和oldval里all的索引,如果没有则返回-1
      if (newindex !== -1 && oldindex === -1 && val.length > 1) {
        //如果新的选择里有勾选了选择所有选择所有 则 只直线勾选所有整个选项
        this.helmetStatusValue = ['all']
      } else if (newindex !== -1 && oldindex !== -1 && val.length > 1) {
        this.helmetStatusValue.splice(val.indexOf('all'), 1) //如果操作前有勾选了选择所有且当前也选中了勾选所有且勾选数量大于1  则移除掉勾选所有
      } else if (val.length === 3) {
        this.helmetStatusValue = ['all']
      }
      if (this.helmetStatusValue[0] === 'all') {
        this.userTreeQueryParam.statusList = null
      } else {
        this.userTreeQueryParam.statusList = val.join(',')
      }
      this.$store.commit('setTreeQuery', this.userTreeQueryParam)
      this._findDeviceList(this.helmetStatusValue)
    },
    // 机构树搜索名字监听
    userName(val) {
      if (val) {
        clearInterval(this.pollInterval)
      } else {
        this._findDeviceList(this.statusList)
        this.pollInterval = setInterval(() => {
          this._findDeviceList(this.statusList)
        }, 10000)
      }
      this.userTreeQueryParam.userName = val
      this.$store.commit('setTreeQuery', this.userTreeQueryParam)
      this.$refs.dataConfigTree.filter(val)
    },
    searchName(val) {
      if (val) {
        clearInterval(this.pollInterval)
      } else {
        this.pollInterval = setInterval(() => {
          this._findDeviceList(this.statusList)
        }, 10000)
      }
      this.$refs.dataConfigTree.filter(val)
    },
  },
  destroyed() {
    // 页面离开时销毁定时器
    clearInterval(this.pollInterval)
  },
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/mixin.styl'
.contain
  width 123%
  height 94%
  .title
    height: 46px;
    line-height: 37px;
    width 97%
    position: relative;
    bg-image('~@/icon/re-new-command/title.png')
    border-radius: 4px 4px 0 0;
    span
      font-size: 18px;
      font-weight: bold;
      color: var(--title-color);
      position: absolute;
      left: 68px;
      top: 5px;
  .tree-block-pack
    height 60px !important
    bg-only('~@/icon/new-command/tree-bg2.png')
  .tree-block
    height 99%
    width 97%
    pointer-events auto;
    background #fff
    position: relative;
    // padding-top: 33px;
    transition: height 0.5s
    .el-aside
      min-width 0px!important;/*no*/
      position relative
      width 100% !important
      // width 350px !important
      // max-width 350px !important
      // min-width 240px !important
      .el-tree-node__content
        height 36px
    .arrow-count
      height 86px;/*no*/
      width 24px;/*no*/
      bg-image('~@/icon/re-new-command/arrow-count-bg.png')
      position absolute
      bottom 60px
      right: -23px;/*no*/
      cursor pointer
      writing-mode: vertical-lr;
      span
        font-size: 12px
        color var(--title-color)
        position absolute
        top: 13px;
        left: 6px;
    .pack-up
      height 63px
      width 24px
      bg-image('~@/icon/re-new-command/arrow-left-bg.png')
      position absolute
      bottom 0
      right: -23px;
      cursor pointer
      writing-mode: vertical-lr;
      span
        font-size: 12px
        color var(--title-color)
        position absolute
        top: 13px;
        left: 6px;
      i
        width 10px
        height 10px
        bg-image('~@/icon/re-new-command/arrow-left.png')
        display: inline-block;
        position: absolute;
        bottom: 3px;
        left: 6px;
    .extend-up
      width 61px
      height: 24px
      bg-image('~@/icon/re-new-command/history/expend.png')
      // margin-top: 4px;
      cursor pointer
      span
        font-size: 12px
        color var(--title-color)
        position absolute
        bottom: -20px
        left: 8px;
      i
        width 10px
        height 10px
        bg-image('~@/icon/re-new-command/arrow-down.png')
        display: inline-block;
        position: absolute;
        bottom: -18px;
        left: 35px;
    .extend-up-numb
      width 91px
      height: 24px
      bg-image('~@/icon/re-new-command/history/expend-numb.png')
      // margin-top: 4px;
      cursor pointer
      position: absolute;
      top: 61px;
      left: 61px;
      span
        font-size: 12px
        color var(--title-color)
        position absolute
        bottom: 4px;
        left: 13px;
    .el-aside
      width 17%
      height 98%
      // padding-top: 31px;
      overflow: hidden;
      background: none !important
      .serachLine
        // width: 97%
        margin 10px
        background #fff
        display flex
        align-items center
        position: relative;
        .el-select
          position: absolute;
          right: 90px;
        .serachBarInput
          width 270px !important
          /deep/ .el-input__inner
            // border #D1DAE7
            color #222
            height 36px;/*no*/
            line-height 36px;/*no*/
          /deep/ .el-input__suffix
            right: 128px;
        .line
          width 1px
          height 22px
          display inline-block
          position: absolute;
          left: 141px;
        .serachBtn
          padding 7px 13px
          margin-right 5px
        .serachBarSelet
          width 125px
          /deep/ .el-input
            width 110% !important
          >>>.el-input__inner
            border none
            height 34px;/*no*/
            line-height 34px;/*no*/
          .serachBarSeletOption
            width 80px
          /deep/ .el-input__inner
            width 81px
            color red !important
            height 34px;/*no*/
            line-height 34px;/*no*/
          /deep/ .el-input__suffix
            right: 15px;

      .monitorTree
        overflow auto
        height 88%
        background: none!important
        margin-top: 10px
        .onlineIcon
          display inline-block
          width 20px
          height 20px
        .tree-gk3-on-night
          bg-image('~@/icon/monitor/map/tree-gk3-on-night.png')
        .tree-gk3-on-day
          bg-image('~@/icon/monitor/map/tree-gk3-on-day.png')
        .tree-gk3-off-day
          bg-image('~@/icon/monitor/map/tree-gk3-off-day.png')
        .tree-gk3-off-night
          bg-image('~@/icon/re-new-command/map/tree-gk3-off-night.png')
        .tree-jls-on-night
          bg-image('~@/icon/monitor/map/tree-jls-on-night.png')
        .tree-jls-on-day
          bg-image('~@/icon/monitor/map/tree-jls-on-day.png')
        .tree-jls-off-night
          bg-image('~@/icon/monitor/map/tree-jls-off-night.png')
        .tree-jls-off-day
          bg-image('~@/icon/monitor/map/tree-jls-off-day.png')
        .tree-law-on-night
          bg-image('~@/icon/monitor/map/lowOnNight.png')
        .tree-law-on-day
          bg-image('~@/icon/monitor/map/lowOnLight.png')
        .tree-low-off-night
          bg-image('~@/icon/monitor/map/lowOffNight.png')
        .tree-low-off-day
          bg-image('~@/icon/monitor/map/lowOffLight.png')
        .tree-lposition-off-night
          bg-image('~@/icon/monitor/map/tree-d-on-night1.png')
        .tree-lposition-off-day
          bg-image('~@/icon/monitor/map/tree-position-on-day1.png')
        .tree-dposition-off-night
          bg-image('~@/icon/monitor/map/tree-d-on-night2.png')
        .tree-dposition-off-day
          bg-image('~@/icon/monitor/map/tree-position-on-day2.png')
        .onlineColor
          color #00DEFF
        .unallotIcon
          display inline-block
          width 20px
          height 20px
          bg-image('~@/icon/helmet_unallot.png')
        .el-tree
          background #EFF1F4
.alert_tree
  .tree-block
    height 100%
    width 100%
  .el-aside
    width 100%!important
    min-width 100%!important
    height: 100%!important
    bg-image-full('~@/icon/newBg/tree_bg.png')
    .el-tree
      background none
    .monitor
      height: 98%
.custom-tree-node
  flex 1
  display flex
  align-items center
  width 100%
  overflow: hidden
  text-overflow: ellipsis
  white-space: nowrap
  .node-txt
    font-size 16px;/*no*/
  .unit-color
    color var(--unit-color)
.leftContain
  .open-all
    padding 8px 12px
    border 1px solid var(--cockpit-all-time-color)
    margin-left: 10px
    border-radius 4px
    font-size 12px
    color var(--cockpit-all-time-color)
    margin 4px 14px
    cursor pointer
    box-sizing: border-box;
    position: absolute;
    right: -7px;
    top: 8px;
.contain
  .title
    pointer-events: auto;
    .order-btn
      border 1px solid var(--cockpit-all-time-color)
      border-radius 2px
      font-size 12px
      color var(--cockpit-all-time-color)
      cursor pointer
      position: absolute;
      right: 7px;
      top: 6px;
      width 72px
      height 32px
      line-height 32px
      text-align center
// 深色模式样式覆盖
.theme-dark
  .contain
    .title
      bg-image('~@/icon/re-new-command/title-m.png')
      span
        color #00E4FF
    .tree-block
      background rgba(0, 42, 150, 0.8)
      .el-aside
        .serachLine
          background #002A96
        .monitorTree
          .tree-gk3-off-night
            bg-image('~@/icon/re-new-command/map/tree-gk3-off-night-m.png')
      .arrow-count
        bg-image('~@/icon/re-new-command/arrow-count-bg-m.png')
      .pack-up
        bg-image('~@/icon/re-new-command/arrow-left-bg-m.png')
        i
          bg-image('~@/icon/re-new-command/arrow-left-m.png')

      .extend-up
        bg-image('~@/icon/re-new-command/history/expend-m.png')
        i
          bg-image('~@/icon/re-new-command/arrow-down-m.png')
      .extend-up-numb
        bg-image('~@/icon/re-new-command/history/expend-numb-m.png')
</style>
